<template>
  <div class="main-container">
    <v-app-bar app color="grey lighten-4" dark :elevation="4">
      <v-app-bar-nav-icon @click="drawer = true" v-if="!topButtons" color="red accent-2"></v-app-bar-nav-icon>
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          :src="require('@/assets/logo.png')"
          transition="scale-transition"
          width="100"
          @click="goTo('/')"
        />
      </div>
      <v-divider class="mx-2 grey lighten-3" inset vertical v-if="topButtons"></v-divider>
      <div v-if="topButtons">
        <template v-for="[key, value] of Object.entries(navigation)">
          <template v-if="(value.admin && isAdmin()) || !value.admin">
            <template v-if="value.items.length === 1">
              <v-btn
                text
                tile
                color="red accent-2"
                @click="goTo(value.items[0].path)"
                :key="value.items[0].title"
              >
                <v-icon left>{{value.icon}}</v-icon>
                <span class="font-weight-black grey--text text--darken-1">{{key}}</span>
              </v-btn>
            </template>
            <template v-else>
              <v-menu offset-y bottom :key="key">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn text tile v-bind="attrs" v-on="on" color="red accent-2">
                    <v-icon left>{{value.icon}}</v-icon>
                    <span class="font-weight-black grey--text text--darken-1">{{key}}</span>
                    <v-icon>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(page, i) in value.items" :key="i" @click="goTo(page.path)">
                    <v-list-item-title>
                      <v-icon left>{{ page.icon }}</v-icon>
                      <span>{{ page.title }}</span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </template>
        </template>
      </div>
      <v-spacer></v-spacer>
      <v-btn icon @click="logout">
        <v-icon color="red accent-2">mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" absolute temporary color="grey lighten-4">
      <v-list nav dense>
        <template v-for="[key, value] of Object.entries(navigation)">
          <template v-if="(value.admin && isAdmin()) || !value.admin">
            <template v-if="value.items.length === 1">
              <v-list-item :key="value.items[0].title" @click="goTo(value.items[0].path)">
                <v-list-item-icon>
                  <v-icon>{{value.icon}}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{key.toUpperCase()}}</v-list-item-title>
              </v-list-item>
            </template>
            <template v-else>
              <v-list-group
                :prepend-icon="value.icon"
                value="true"
                :key="key"
                active-class="red--text text--accent-2"
              >
                <template v-slot:activator>
                  <v-list-item-title>{{key.toUpperCase()}}</v-list-item-title>
                </template>
                <v-list-item v-for="(page, i) in value.items" :key="i" @click="goTo(page.path)">
                  <v-list-item-title class="pl-4">
                    <v-icon left>{{ page.icon }}</v-icon>
                    <span>{{ page.title }}</span>
                  </v-list-item-title>
                </v-list-item>
              </v-list-group>
            </template>
          </template>
        </template>
      </v-list>
    </v-navigation-drawer>
    <router-view></router-view>
    <ErrorSnackbar />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Roles from "@/router/roles";
import ErrorSnackbar from "@/views/ErrorSnackbar";

export default {
  components: { ErrorSnackbar },
  data: () => {
    return {
      collapse: true,
      drawer: false,
    };
  },
  computed: {
    ...mapState({
      navigation: (state) => state.navigation.all,
    }),
    topButtons() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return false;
        case "sm":
          return false;
        case "md":
          return true;
        case "lg":
          return true;
        case "xl":
          return true;
      }
      return "100%";
    },
  },
  methods: {
    goTo(route) {
      if (this.$router.currentRoute.path !== route) {
        this.$router.push(route);
      }
    },
    isAdmin() {
      return this.$auth.getUserRoles().includes(Roles.Admin) || this.$auth.getUserRoles().includes(Roles.OrderPipelineAdministrator);
    },
    logout() {
      this.$auth.logout();
    },
  },
};
</script>
